import { useCallback } from 'react';

export default function createTrackingCodeParser(trackingCodes = null) {
    const extraCodes = trackingCodes || [];
    return (story) => {
        if (extraCodes.length <= 0 || story === null) {
            return story;
        }
        const { settings = {} } = story;
        const { tracking = {} } = settings || {};
        const { codes = [] } = tracking || {};
        return {
            ...story,
            settings: {
                ...settings,
                tracking: {
                    ...tracking,
                    codes: [
                        ...(codes || []),
                        ...extraCodes.map((code) => ({
                            id: code,
                            type: 'ga4',
                        })),
                    ],
                },
            },
        };
    };
}

export function parseStory(story, parsers) {
    return (parsers || []).reduce((parsedStory, parser) => parser(parsedStory), story);
}

export function useStoryParser(parsers) {
    return useCallback((story) => parseStory(story, parsers), [parsers]);
}
